import { render } from "./SectionCard.vue?vue&type=template&id=0856dd8a&scoped=true"
import script from "./SectionCard.vue?vue&type=script&lang=js"
export * from "./SectionCard.vue?vue&type=script&lang=js"

import "./SectionCard.vue?vue&type=style&index=0&id=0856dd8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0856dd8a"]])

export default __exports__